import { render } from "./myquestionnaireDesc.vue?vue&type=template&id=14238f79&scoped=true"
import script from "./myquestionnaireDesc.vue?vue&type=script&lang=js"
export * from "./myquestionnaireDesc.vue?vue&type=script&lang=js"

import "./myquestionnaireDesc.vue?vue&type=style&index=0&id=14238f79&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14238f79"]])

export default __exports__